module.exports = __webpack_public_path__ + "static/media/4-2-mobile.d13db9e6.webp";